import { render, staticRenderFns } from "./AllocatedBackorderHistoryContainer.vue?vue&type=template&id=02e76c32&scoped=true&"
import script from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryContainer.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedBackorderHistoryContainer.vue?vue&type=style&index=0&id=02e76c32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e76c32",
  null
  
)

export default component.exports